/* eslint-disable */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Space } from 'antd';
import { useHistory, useLocation } from 'react-router';
import styled, { css } from 'styled-components';
import colors from '~/constants/colors';
import { CheckmarkIcon, CircleIcon } from '~/img';
import { useSelectStep } from '~/controllers/wizard';
import { ApplicationStep } from '~/types/ApplicationStep';
import { useDirection } from '~/hooks/i18nHooks';

export interface ApplicationNavStepProps extends ApplicationNavStepStateProps {
  index: number;
  name: string;
  stepKey: any;
  // @ts-ignore
  uiKey: ApplicationStep['uiKey'];
  route: string;
  onClick?: () => void;
}

interface ApplicationNavStepStateProps {
  disabled: boolean;
  done: boolean;
  validationError: boolean;
  active?: boolean;
  stageKey?: string;
}

const ChildNavStep: FC<ApplicationNavStepProps> = (props) => {
  const { t } = useTranslation('ksaApplication');
  const {
    index,
    name,
    route,
    stepKey,
    onClick,
    disabled,
    done,
    active,
    validationError,
    stageKey,
  } = props;
  const history = useHistory();
  const location = useLocation();
  const selectStepMutation = useSelectStep();
  const dir = useDirection();
  const handleNavClick = async () => {
    if (onClick) {
      onClick();
    } else if (!disabled) {
      try {
        console.log('ste2323pKey', stepKey);
        history?.push(route);
        await selectStepMutation.mutateAsync({ stepKey, stageKey });
      } catch (error) {
        //
      }
    }
  };

  return (
    <Container
      dir={dir}
      id={`ApplicationNavStep_${route}`}
      className="ApplicationNavStep"
      onClick={handleNavClick}
      disabled={disabled}
      done={done}
      validationError={validationError}
      active={active ?? location.pathname === route}
    >
      <Space size={8} align="center">
        <div className="ApplicationNavStep-Index">
          <></>
        </div>
        <div className="ApplicationNavStep-Text">{t(name)}</div>
      </Space>
    </Container>
  );
};

const Container = styled.nav<ApplicationNavStepStateProps>`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  margin-top: -5px;
  margin-bottom: -5px;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
  margin-right: ${({ dir }) => (dir === 'rtl' ? '5px' : 'unset')};
  display: flex;
  .ApplicationNavStep-Index {
    margin-left: 7.5px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 9px;
    width: 9px;
    aspect-ratio: 1;
    border-radius: 9px;
    border-width: 1.5px;
    border-style: solid;
    span {
      font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
      display: flex;
      font-weight: 600;
      font-size: 10px;
      line-height: 15px;
      vertical-align: middle;
    }
    .ApplicationNavStep-CheckmarkIcon {
      font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
      color: ${colors.componentBackground};
      font-size: 4px;
    }
    ${({ disabled, done }) =>
    disabled && done
      ? css`
            background-color: ${colors.blue[1100]}; !important;
            // border-color: ${colors.disabledBlueTextColor};
            color: ${colors.disabledBlueTextColor} !important;
          `
      : disabled
        ? css`
            background-color: #6e6e71 !important;
            // border-color: ${colors.disabledBlueTextColor};
            color: ${colors.disabledBlueTextColor} !important;
          `
        : css`
            border-color: ${colors.blue[1100]};
          `}
    ${({ active }) =>
    active
      ? css`
            background-color: ${colors.blue[1100]};
            color: ${colors.componentBackground};
          `
      : css`
            background-color: ${colors.blue[1100]};
            color: ${colors.componentBackground};
          `}
    ${({ done }) =>
    done
      ? css`
            background-color: ${colors.blue[1100]};
            border-color: ${colors.blue[1100]};
            color: ${colors.componentBackground};
          `
      : css`
            //
          `}
    ${({ validationError }) =>
    validationError
      ? css`
            background-color: ${colors.warningColor};
            border-color: ${colors.warningColor};
            color: ${colors.componentBackground};
          `
      : css`
            //
          `}
  }
  .ApplicationNavStep-Text {
    white-space: nowrap;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    margin-left: 15.5px;
    ${({ active }) =>
    active
      ? css`
            font-weight: 600;
          `
      : css``}

    ${({ disabled }) =>
    disabled
      ? css`
            color: ${colors.disabledUpComingTextColor};
          `
      : css`
            //
          `}
  }
`;

export default ChildNavStep;
